// extracted by mini-css-extract-plugin
export default {"Team":"Team_Team__NZLHU","btnDiv":"Team_btnDiv__nwFv+","alumniBtn":"Team_alumniBtn__JbM1x"};